export enum NotationManagementActionType {
  SetNotations = 'set_notations',
  SetCategories = 'set_categories',
  SetFilterNotationType = 'set_filter_notation_type',
  RemoveNotationType = 'remove_notation_type',
  SetFilterCategory = 'set_filter_category',
  RemoveCategory = 'remove_category',
  SetCreatedBy = 'set_created_by',
  SetCreatedFor = 'set_created_for',
  SetStartDate = 'set_start_date',
  SetEndDate = 'set_end_date',
  DeleteNotation = 'delete_notation',
  LowerAlerts = 'lower_alert',
  EditNotation = 'edit_notation',
  SetNotationsLoading = 'set_notations_loading',
  Reset = 'reset',
  AssignTo = 'assign_to',
  SetHasMoreNotation = 'set_has_more_notation',
  OpenLowerAlert = 'open_lower_alert',
  OpenDeleteNotationConfirmation = 'open_delete_notation_confirmation',
  OpenExpandedNotation = 'open_expanded_notation',
  NotationSelected = 'notation_selected',
  CloseModal = 'close_modal',
  SelectAll = 'select_all',
  DeselectAll = 'deselect_all',
  SetTotalNotations = 'set_total_notations',
  SetNotationFilters = 'set_notation_filters',
}
